<p-dialog
  [(visible)]="dialogVisible"
  [header]="typeExport=='XLSX' ? ('attribute.exportToExcel' | transloco) : ('attribute.exportToCsv' | transloco)"
  [style]="{ width: typeContent === 'MACHINE' || (typeContent === 'ALARM' && exportFileType === ExportFileType.MACHINE_ALARMS_LIST) || typeContent === 'AUDIT' ? '50vw' : '30vw' }"
  [draggable]="false"
  [resizable]="true"
  [modal]="true"
  (onHide)="visibleChange.emit(false)"
  appendTo="body"
>
  <hr class="mt-0">
  <div class="flex flex-column">
    <div class="grid">
      <div class="col-12 md:col-12" [ngClass]="typeContent === 'MACHINE' || (typeContent === 'ALARM' && exportFileType === ExportFileType.MACHINE_ALARMS_LIST) || typeContent === 'AUDIT' ? 'lg:col-6' : 'lg:col-12'">
        <div class="form-field col-12">
          <label for="archiveName">{{'attribute.fileName' | transloco}}:</label>
        </div>
        <div class="col-12">
          <input pInputText id="archiveName" type="text"  class="w-full" [(ngModel)]="fileName"
                 (keyup.enter)="saveAndClose()" [focus]="dialogVisible" appAutoFocus>
        </div>
      </div>
      <div *ngIf="typeContent === 'MACHINE' || (typeContent === 'ALARM' && exportFileType === ExportFileType.MACHINE_ALARMS_LIST) || typeContent === 'AUDIT'" class="col-12 md:col-12 lg:col-6">
        <div class="form-field col-12">
          <label>{{'attribute.contentExport' | transloco}}:</label>
        </div>
        <div class="col-12 p-3">
          <p-radioButton [label]="'select.currentPage' | transloco"
                         class="mr-3"
                         name="typeExport"
                         value="currentPage"
                         [(ngModel)]="contentTypeExport">
          </p-radioButton>
          <p-radioButton [label]="'select.allPages' | transloco"
                         name="typeExport"
                         value="allPages"
                         [(ngModel)]="contentTypeExport">
          </p-radioButton>
        </div>
      </div>
    </div>
  </div>

  <div class="flex justify-content-between py-4">
    <div>
      <button
        [label]="'common.cancel' | transloco"
        [disabled]="loadingContent == true"
        (click)="closeWithoutSaving()"
        pButton
        class="mr-2 p-button-danger"
      ></button>
    </div>
    <div class="flex justify-content-end">
      <button
        [label]="'common.export' | transloco"
        [disabled]="!fileName || fileName.length === 0 || loadingContent == true"
        (click)="saveAndClose()"
        [icon]="loadingContent == true ? 'pi pi-spin pi-spinner' : ''"
        pButton
        class="p-button-primary"
        iconPos="right"
      ></button>
    </div>
  </div>

</p-dialog>
